import { __assign, __awaiter, __generator, __read, __spread } from "tslib";
import React, { useEffect, useState } from 'react';
import { app } from '@ekuaibao/whispered';
import { getDeptItemsByIds, getExternalStaffItemByIds, getRoleItemByIds, getStaffItemByIds, tagLabelLimit as labelLimit } from './utile';
import TagShow from '../tag-show';
import SubCollectionTip from '../sub-collection-tip';
export var Index = function (_a) {
    var includeChildrenDisabled = _a.includeChildrenDisabled, value = _a.value, placeholder = _a.placeholder, onValueChange = _a.onValueChange, bus = _a.bus, disabled = _a.disabled, _b = _a.tagStrLimit, tagStrLimit = _b === void 0 ? 18 : _b, showIncludeChildren = _a.showIncludeChildren, tagLabelLimit = _a.tagLabelLimit, includeSubWrapperStyle = _a.includeSubWrapperStyle, className = _a.className, tagShowClassName = _a.tagShowClassName, tagShowStyle = _a.tagShowStyle, maxTagCount = _a.maxTagCount, showMaxTagCountTooltip = _a.showMaxTagCountTooltip, allowExternal = _a.allowExternal, allowClear = _a.allowClear;
    var _c = __read(useState([]), 2), tags = _c[0], setTags = _c[1];
    useEffect(function () {
        parseValue();
    }, [value]);
    var parseValue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, t, isChange, newValue, newObjValue;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, valueParse(value, showIncludeChildren)];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 4]), t = _a[0], isChange = _a[1], newValue = _a[2], newObjValue = _a[3];
                    setTags(t);
                    if (isChange) {
                        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(newValue, newObjValue);
                    }
                    return [2];
            }
        });
    }); };
    var handleSelectStaff = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, departments, _c, roles, _d, staffs, _e, externalList, data, checkedList, staffData, departmentData, roleData, staffIds, departmentIds, roleIds, val, objValue, externalData;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = value || {}, _b = _a.departments, departments = _b === void 0 ? [] : _b, _c = _a.roles, roles = _c === void 0 ? [] : _c, _d = _a.staffs, staffs = _d === void 0 ? [] : _d, _e = _a.externalList, externalList = _e === void 0 ? [] : _e;
                    data = [
                        {
                            type: 'department-member',
                            checkIds: (staffs === null || staffs === void 0 ? void 0 : staffs.map(function (item) { return item.id || item; }).filter(Boolean)) || []
                        }
                    ];
                    if (allowExternal) {
                        data.push({
                            type: 'external',
                            checkIds: (externalList === null || externalList === void 0 ? void 0 : externalList.map(function (item) { return item.id || item; }).filter(Boolean)) || []
                        });
                    }
                    data.push({
                        type: 'department',
                        checkIds: (departments === null || departments === void 0 ? void 0 : departments.map(function (item) { return item.id || item; }).filter(Boolean)) || []
                    });
                    data.push({
                        type: 'role',
                        checkIds: (roles === null || roles === void 0 ? void 0 : roles.map(function (item) { return item.id || item; }).filter(Boolean)) || []
                    });
                    return [4, app.open('@organizationManagement:SelectStaff', {
                            multiple: true,
                            data: data
                        })];
                case 1:
                    checkedList = _f.sent();
                    staffData = checkedList.find(function (o) { return o.type === 'department-member'; });
                    departmentData = checkedList.find(function (o) { return o.type === 'department'; });
                    roleData = checkedList.find(function (o) { return o.type === 'role'; });
                    staffIds = staffData.checkIds || [];
                    departmentIds = departmentData.checkIds || [];
                    roleIds = roleData.checkIds || [];
                    val = __assign(__assign({}, value), { departments: departmentIds, staffs: staffIds, roles: roleIds });
                    objValue = __assign(__assign({}, value), { departments: departmentData.checkList || [], staffs: staffData.checkList || [], roles: roleData.checkList || [] });
                    if (allowExternal) {
                        externalData = checkedList.find(function (o) { return o.type === 'external'; });
                        objValue.externalList = externalData.checkList || [];
                        val.externalList = externalData.checkIds || [];
                    }
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(val, objValue);
                    return [2];
            }
        });
    }); };
    var handleChange = function (values) {
        var va = { departments: [], staffs: [], roles: [], externalList: [] };
        var objVa = { departments: [], staffs: [], roles: [], externalList: [] };
        var keyMap = {
            department: 'departments',
            staff: 'staffs',
            role: 'roles',
            external: 'externalList'
        };
        tags
            .filter(function (item) { return item.id !== 'departmentsIncludeChildren' && values.includes(item.id); })
            .forEach(function (item) {
            var key = keyMap[item.type];
            va[key].push(item.id);
            objVa[key].push(item);
        });
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(__assign(__assign({}, value), va), __assign(__assign({}, value), objVa));
        if (bus === null || bus === void 0 ? void 0 : bus.has('fields:blur')) {
            bus.emit('fields:blur');
        }
    };
    var handleIncludeChildren = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var val, _a, departments, staffs, roles, objValue;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.stopPropagation();
                    val = __assign(__assign({}, value), { departmentsIncludeChildren: e.target.checked });
                    return [4, Promise.all([
                            getDeptItemsByIds(value.departments || [])(),
                            getStaffItemByIds(value.staffs || [])(),
                            getRoleItemByIds(value.roles || [])()
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 3]), departments = _a[0], staffs = _a[1], roles = _a[2];
                    objValue = { staffs: staffs, departments: departments, roles: roles, departmentsIncludeChildren: e.target.checked };
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(val, objValue);
                    return [2];
            }
        });
    }); };
    return (React.createElement("div", { className: className },
        React.createElement(TagShow, { placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : i18n.get('请选择人员'), tags: tags, disabled: disabled, onClick: handleSelectStaff, onChange: handleChange, tagLabelLimit: tagLabelLimit ? tagLabelLimit : function (tag) { return labelLimit(tag, tagStrLimit); }, className: tagShowClassName, style: tagShowStyle, maxTagCount: maxTagCount, showMaxTagCountTooltip: showMaxTagCountTooltip, allowClear: allowClear }),
        showIncludeChildren && (React.createElement(SubCollectionTip, { disabled: includeChildrenDisabled, wrapperStyle: includeSubWrapperStyle, checked: value === null || value === void 0 ? void 0 : value.departmentsIncludeChildren, onChange: handleIncludeChildren, subIncludeStr: i18n.get('适用于子部门'), includeChildrenToolTipStr: i18n.get('勾选后，适用于所选部门及其所有子部门；如未勾选，只对所选部门自身生效。'), tooltipIconStyle: { fontSize: 16, transform: 'translateY(1px)' } }))));
};
var valueParse = function (value, showIncludeChildren) {
    if (showIncludeChildren === void 0) { showIncludeChildren = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var departmentIds, staffIds, roleIds, externalStaffIds, _a, departments, staffs, roles, externalList, data, isChange, result;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!value) {
                        return [2, [[], false]];
                    }
                    departmentIds = ((_b = value.departments) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.id || item; }).filter(Boolean)) || [];
                    staffIds = ((_c = value.staffs) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item.id || item; }).filter(Boolean)) || [];
                    roleIds = ((_d = value.roles) === null || _d === void 0 ? void 0 : _d.map(function (item) { return item.id || item; }).filter(Boolean)) || [];
                    externalStaffIds = ((_e = value.externalList) === null || _e === void 0 ? void 0 : _e.map(function (item) { return item.id || item; }).filter(Boolean)) || [];
                    return [4, Promise.all([
                            getDeptItemsByIds(departmentIds)(),
                            getStaffItemByIds(staffIds)(),
                            getRoleItemByIds(roleIds)(),
                            getExternalStaffItemByIds(externalStaffIds)()
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_f.sent(), 4]), departments = _a[0], staffs = _a[1], roles = _a[2], externalList = _a[3];
                    data = __spread(departments, staffs, roles, externalList);
                    isChange = departmentIds.length !== departments.length || staffIds.length !== staffs.length || roleIds.length !== roles.length;
                    result = [];
                    if (showIncludeChildren && value.departmentsIncludeChildren) {
                        result.push({
                            id: 'departmentsIncludeChildren',
                            label: i18n.get('含子部门'),
                            showAvatar: false,
                            tagOptions: { color: 'pri', fill: 'outline', closable: false }
                        });
                    }
                    return [2, [
                            result.concat(data),
                            isChange,
                            __assign(__assign({}, value), { departments: departments.map(function (item) { return item.id; }), staffs: staffs.map(function (item) { return item.id; }), roles: roles.map(function (item) { return item.id; }), externalList: externalList.map(function (item) { return item.id; }) }),
                            __assign(__assign({}, value), { departments: departments, staffs: staffs, roles: roles, externalList: externalList })
                        ]];
            }
        });
    });
};
export default Index;
